export const formatDate = (dateString) => {
  if (!dateString) return '-';
  
  try {
    const date = new Date(dateString);
    
    if (isNaN(date.getTime())) {
      return 'Date invalide';
    }
    
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Date invalide';
  }
};

export const formatStatus = (status) => {
  const statusMap = {
    'lead': 'Lead',
    'consultation': 'Consultation',
    'quote_sent': 'Devis envoyé',
    'in_progress': 'En cours',
    'completed': 'Terminé',
    'archived': 'Archivé',
    'new': 'Nouveau',
    'read': 'Lu',
    'replied': 'Répondu'
  };
  
  return statusMap[status] || status;
};

export const getStatusColor = (status) => {
  const colors = {
    'lead': 'bg-blue-100 text-blue-800',
    'consultation': 'bg-yellow-100 text-yellow-800',
    'quote_sent': 'bg-purple-100 text-purple-800',
    'in_progress': 'bg-green-100 text-green-800',
    'completed': 'bg-gray-100 text-gray-800',
    'archived': 'bg-red-100 text-red-800',
    'new': 'bg-blue-100 text-blue-800',
    'read': 'bg-gray-100 text-gray-800',
    'replied': 'bg-green-100 text-green-800'
  };
  
  return colors[status] || 'bg-gray-100 text-gray-800';
};

export const formatPrice = (amount) => {
  if (!amount && amount !== 0) return '-';
  
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);
};

export const formatPhone = (phone) => {
  if (!phone) return '-';
  
  const cleaned = phone.replace(/\D/g, '');
  
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
  }
  
  return phone;
};